import { observer } from 'mobx-react';
import React from 'react';

import DocumentSearch, { DocumentSearchState } from '../controls/documents/DocumentSearch';
import API, { IUserConfigPackage } from '../../API';

export class StandaloneSearchTabState {

	public docSearchState: DocumentSearchState;

	constructor(userConfig: IUserConfigPackage) {
		this.docSearchState = new DocumentSearchState(userConfig, true, async (item) => {
			
			var api = new API(await userConfig.getToken());
			let downloadLink = await api.prepareDownloadLink(item.webUrl);

			let filename = item.name;

			if(!filename) {
				filename = "document";
			}

			//Add the file extension from the webUrl to the name
			if(filename.indexOf('.') === -1) {
				let extIndex = item.webUrl.lastIndexOf('.');
				if (extIndex !== -1) {
					filename += item.webUrl.substring(extIndex);
				}
			}


			// Handle the attachment logic here
			Office.context.ui.messageParent(JSON.stringify({
				method: 'insertFileAttachment',
				name: filename,
				uri: downloadLink
			}));

		});
	}
}

export interface IStandaloneSearchTabProps {
	state: StandaloneSearchTabState;
}

class StandaloneSearchTab extends React.Component<IStandaloneSearchTabProps> {

	render() {

		return <DocumentSearch state={this.props.state.docSearchState} />

	}
}

export default observer(StandaloneSearchTab);
